module.exports = __webpack_public_path__ + "static/media/Паспорт на Галеон серии S LED.28b6def7.pdf";